"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericEquipment = exports.VenstarMini = exports.VenstarExplorer = exports.UnoxOven = exports.SiteAverage = exports.ShellyTemperature = exports.ShellyLighting = exports.ShellyDoorSensor = exports.Shelly1PMWarning = exports.Shelly1PMTempHum = exports.Shelly1PMTemp3Probe = exports.Shelly1PMTemp2Probe = exports.Shelly1PMTemp1Probe = exports.Shelly1PMLighting = exports.Shelly1PMDryContact = exports.Shelly1PMContactSwitch = exports.NiagaraSettings = exports.NiagaraRefrigerationTemperature = exports.NiagaraLightingOverride = exports.NiagaraLighting = exports.NiagaraFlexStat = exports.Niagara8650 = exports.NavitasTemperature = exports.LogiCO21Sensor = exports.Kaiterra = exports.CricketSensor = exports.BACNETFlexstatRTU = exports.BACNETFlexstatLighting = exports.BACNET8650 = exports.AR750SGateway = exports.EquipmentPrimitiveTypes = exports.EquipmentTypes = void 0;
/* istanbul ignore file */
var PrimitiveTypes_1 = require("./PrimitiveTypes");
Object.defineProperty(exports, "EquipmentPrimitiveTypes", { enumerable: true, get: function () { return PrimitiveTypes_1.EquipmentPrimitiveTypes; } });
var AR750SGateway_1 = require("./AR750SGateway");
exports.AR750SGateway = AR750SGateway_1.default;
var BACNET8650_1 = require("./BACNET8650");
exports.BACNET8650 = BACNET8650_1.default;
var BACNETFlexstatLighting_1 = require("./BACNETFlexstatLighting");
exports.BACNETFlexstatLighting = BACNETFlexstatLighting_1.default;
var BACNETFlexstatRTU_1 = require("./BACNETFlexstatRTU");
exports.BACNETFlexstatRTU = BACNETFlexstatRTU_1.default;
var CricketSensor_1 = require("./CricketSensor");
exports.CricketSensor = CricketSensor_1.default;
var Kaiterra_1 = require("./Kaiterra");
exports.Kaiterra = Kaiterra_1.default;
var LogiCO21Sensor_1 = require("./LogiCO21Sensor");
exports.LogiCO21Sensor = LogiCO21Sensor_1.default;
var NavitasTemperature_1 = require("./NavitasTemperature");
exports.NavitasTemperature = NavitasTemperature_1.default;
var Niagara8650_1 = require("./Niagara8650");
exports.Niagara8650 = Niagara8650_1.default;
var NiagaraFlexStat_1 = require("./NiagaraFlexStat");
exports.NiagaraFlexStat = NiagaraFlexStat_1.default;
var NiagaraLighting_1 = require("./NiagaraLighting");
exports.NiagaraLighting = NiagaraLighting_1.default;
var NiagaraLightingOverride_1 = require("./NiagaraLightingOverride");
exports.NiagaraLightingOverride = NiagaraLightingOverride_1.default;
var NiagaraRefrigerationTemperature_1 = require("./NiagaraRefrigerationTemperature");
exports.NiagaraRefrigerationTemperature = NiagaraRefrigerationTemperature_1.default;
var NiagaraSettings_1 = require("./NiagaraSettings");
exports.NiagaraSettings = NiagaraSettings_1.default;
var Shelly1PMContactSwitch_1 = require("./Shelly1PMContactSwitch");
exports.Shelly1PMContactSwitch = Shelly1PMContactSwitch_1.default;
var Shelly1PMDryContact_1 = require("./Shelly1PMDryContact");
exports.Shelly1PMDryContact = Shelly1PMDryContact_1.default;
var Shelly1PMLighting_1 = require("./Shelly1PMLighting");
exports.Shelly1PMLighting = Shelly1PMLighting_1.default;
var Shelly1PMTemp1Probe_1 = require("./Shelly1PMTemp1Probe");
exports.Shelly1PMTemp1Probe = Shelly1PMTemp1Probe_1.default;
var Shelly1PMTemp2Probe_1 = require("./Shelly1PMTemp2Probe");
exports.Shelly1PMTemp2Probe = Shelly1PMTemp2Probe_1.default;
var Shelly1PMTemp3Probe_1 = require("./Shelly1PMTemp3Probe");
exports.Shelly1PMTemp3Probe = Shelly1PMTemp3Probe_1.default;
var Shelly1PMTempHum_1 = require("./Shelly1PMTempHum");
exports.Shelly1PMTempHum = Shelly1PMTempHum_1.default;
var Shelly1PMWarning_1 = require("./Shelly1PMWarning");
exports.Shelly1PMWarning = Shelly1PMWarning_1.default;
var ShellyDoorSensor_1 = require("./ShellyDoorSensor");
exports.ShellyDoorSensor = ShellyDoorSensor_1.default;
var ShellyLighting_1 = require("./ShellyLighting");
exports.ShellyLighting = ShellyLighting_1.default;
var ShellyTemperature_1 = require("./ShellyTemperature");
exports.ShellyTemperature = ShellyTemperature_1.default;
var SiteAverage_1 = require("./SiteAverage");
exports.SiteAverage = SiteAverage_1.default;
var UnoxOven_1 = require("./UnoxOven");
exports.UnoxOven = UnoxOven_1.default;
var VenstarExplorer_1 = require("./VenstarExplorer");
exports.VenstarExplorer = VenstarExplorer_1.default;
var VenstarMini_1 = require("./VenstarMini");
exports.VenstarMini = VenstarMini_1.default;
var GenericEquipment_1 = require("./GenericEquipment");
exports.GenericEquipment = GenericEquipment_1.default;
var EquipmentTypes = [
    AR750SGateway_1.default,
    BACNET8650_1.default,
    BACNETFlexstatLighting_1.default,
    BACNETFlexstatRTU_1.default,
    CricketSensor_1.default,
    Kaiterra_1.default,
    LogiCO21Sensor_1.default,
    NavitasTemperature_1.default,
    Niagara8650_1.default,
    NiagaraFlexStat_1.default,
    NiagaraLighting_1.default,
    NiagaraLightingOverride_1.default,
    NiagaraRefrigerationTemperature_1.default,
    NiagaraSettings_1.default,
    Shelly1PMContactSwitch_1.default,
    Shelly1PMDryContact_1.default,
    Shelly1PMLighting_1.default,
    Shelly1PMTemp1Probe_1.default,
    Shelly1PMTemp2Probe_1.default,
    Shelly1PMTemp3Probe_1.default,
    Shelly1PMTempHum_1.default,
    Shelly1PMWarning_1.default,
    ShellyDoorSensor_1.default,
    ShellyLighting_1.default,
    ShellyTemperature_1.default,
    SiteAverage_1.default,
    UnoxOven_1.default,
    VenstarExplorer_1.default,
    VenstarMini_1.default
];
exports.EquipmentTypes = EquipmentTypes;
